import lazyLoading from './lazyLoading'

export default {
  name: 'Echo example',
  path: '/echo',
  redirect: '/echo/count',
  meta: {
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('echo', true),

  children: [
    {
      name: 'echo example',
      path: 'count',
      meta: {
        label: 'echo count',
        link: 'echo/Count.vue'
      },
      component: lazyLoading('echo/Count')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/echo.js